module.exports = __webpack_public_path__ + "static/media/jimmy_anekdote.df8180b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/jimmy_anekdote.mp3
// module id = vMkh
// module chunks = 1